import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PublicRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  if (user?.role?.name === "admin") {
    return <Navigate to="/institute/home" replace />;
  } else if (user?.role?.name === "superadmin") {
    return <Navigate to="/admin/home" replace />;
  } else if (user?.role?.name === "teacher") {
    return <Navigate to="/teacher/home" replace />;
  }

  return <Outlet />;
};

export default PublicRoutes;
